<template>
  <div>
    <ParcelshopPicker :typeLivraisonFilter="typeLivraisonFilter" :postalCode="postalCode" :priceMode="priceMode" :selectionMode="selectionMode" :postcode="postcode" :country-code="countryCode" :town="town" :printInStore="printInStore" :showFilterPrintInStore="showFilterPrintInStore" :showFilterLocker="showFilterLocker" :isPrintInStoreHighlighted="isPrintInStoreHighlighted" :isLockerHighlighted="isLockerHighlighted" :authorizedNatures="authorizedNatures"/>
  </div>
</template>

<script>
import ParcelshopPicker from './components/ParcelshopPicker/ParcelshopPicker.vue'

export default {
  components: {
    ParcelshopPicker
  },
  props: {
    selectionMode: {
      type: Boolean,
      required: false
    },
    priceMode: {
      type: Boolean,
      required: false
    },
    postcode: {
      type: String,
      required: false
    }, 
    town: {
      type: String,
      required: false
    }, 
    countryCode: {
      type: String,
      required: false 
    }, 
    printInStore: {
      type: Boolean,
      required: false 
    }, 
    showFilterPrintInStore: {
      type: Boolean,
      required: false 
    },
    showFilterLocker: {
      type: Boolean,
      required: false 
    },
    isPrintInStoreHighlighted: {
      type: Boolean,
      required: false
    },
    isLockerHighlighted: {
      type: Boolean,
      required: false
    },
    authorizedNatures: {
      type: String,
      required: false 
    },
    relayPointsExcluded:{
      type: Array,
      required: false
    },
    typeLivraisonFilter: {
      type: String,
      required: false
    }
  },
  created(){
    if(this.relayPointsExcluded != null){
      this.$store.commit("setRelayPointsExcluded", this.relayPointsExcluded)
    }
  },
  mounted() {
    window.addEventListener("updateDeliveryModeEvent", this.handleUpdateDeliveryMode);
    window.addEventListener("updateCompatibleRelayPoints", this.handleUpdateCompatibleRelayPoints);
  },
  unmounted() {
    window.removeEventListener("updateDeliveryModeEvent", this.handleUpdateDeliveryMode);
    window.removeEventListener("updateCompatibleRelayPoints", this.handleUpdateCompatibleRelayPoints);
  },
  methods: {
    handleUpdateDeliveryMode(event) {
      const hasChanged = this.$store.state.params.typeLivraisonFilter !== event.detail;
      this.$store.commit("setTypeLivraisonFilter", event.detail);
      if (hasChanged) {
        // Les natures envoyées à l'API dépendent du mode (locker / pudo): la liste déjà reçue n'est plus valable
        this.$store.dispatch("scheduleRefreshSearch");
      }
      this.$store.dispatch("getDisplayedParcelDeliveryPoints");
      this.$store.commit("setSelectedParcelshopId", null);
    },
    handleUpdateCompatibleRelayPoints(event) {
      const hasChanged = this.$store.state.params.allowedRelayPoints !== event.detail;
      this.$store.commit("setAllowedRelayPoints", event.detail);
      if (hasChanged) {
        // Les natures envoyées à l'API changent: la liste déjà reçue n'est plus valable
        this.$store.dispatch("scheduleRefreshSearch");
      }
      this.$store.dispatch("getDisplayedParcelDeliveryPoints");
      this.$store.commit("setSelectedParcelshopId", null);
    },
  },
}
</script>

